var shared = require('../internals/shared');

var functionToString = Function.toString;

module.exports = shared('inspectSource', function (it) {
  return functionToString.call(it);
});



//////////////////
// WEBPACK FOOTER
// ./node_modules/@drawbotics/jakte-plugin/node_modules/core-js/internals/inspect-source.js
// module id = 298
// module chunks = 0